export const siteConfig = {
  name: process.env.REACT_APP_SITE_NAME || "FEA Slots",
  domain: process.env.REACT_APP_SITE_DOMAIN || "feaslots.com",
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "support@feaslots.com",
  logoUrl: process.env.REACT_APP_SITE_LOGO_URL || "/fea-profile.jpg",
  androidAppDownloadUrl: process.env.REACT_APP_ANDROID_APK_URL || "/downloads/FEA-Slots.apk",
  adminAppDownloadUrl: process.env.REACT_APP_ADMIN_ANDROID_APK_URL || "/downloads/FEA-Slots-Admin.apk",
  guestEmailDomain: process.env.REACT_APP_GUEST_EMAIL_DOMAIN || "guest.feaslots.com.local",
  storagePrefix: process.env.REACT_APP_STORAGE_PREFIX || "feaslots",
};

export const storageKey = (name) => `${siteConfig.storagePrefix}_${name}`;
export const appEventName = (name) => `${siteConfig.storagePrefix}:${name}`;
